import { render, staticRenderFns } from "./ContactInput.vue?vue&type=template&id=2089da16&scoped=true"
import script from "./ContactInput.vue?vue&type=script&lang=js"
export * from "./ContactInput.vue?vue&type=script&lang=js"
import style0 from "./ContactInput.vue?vue&type=style&index=0&id=2089da16&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2089da16",
  null
  
)

export default component.exports